import React from 'react';
import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getAccessSettings,
  createAccessSettings,
  updateAccessSettings,
  deleteAccessSettings,
} from "@icarius-connection/api";
import { openDialogAction } from "@icarius-common/dialog/actions";

const displayUserProcessError = (dispatch) => {
  dispatch(openDialogAction({
    title: getLocalizedString("atention"),
    msg: <>
      {getLocalizedString("userAssignedToCalculation1")}
      <br />
      <br />
      {getLocalizedString("userAssignedToCalculation2")}
    </>,
    acceptOnly: true,
  }));
}

export const getAccessSettingsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ACCESS_SETTINGS });
  try {
    let response = await getAccessSettings();

    dispatch({
      type: actionTypes.GET_ACCESS_SETTINGS_FULFILLED,
      payload: {
        accessRows: response.data.result.rows,
        groups: response.data.result.groups,
        users: response.data.result.users,
        accessMap: response.data.result.accessMap,
      }
    });

    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ACCESS_SETTINGS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e.response;
  }
};

//UPDATES
export const updateAccessSettingsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_ACCESS_SETTINGS });
  try {
    let response = await updateAccessSettings({ accessSettings: data });

    dispatch({ type: actionTypes.UPDATE_ACCESS_SETTINGS_FULFILLED });
    dispatch(openSnackbarAction({ msg: getLocalizedString("managersUpdatedOK"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("errorTwoEmployersAlready"), severity: "error" }));
    } else {
      if (e.response.data.status === "USER_PROCESS") {
        displayUserProcessError(dispatch);
      } else {
        dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
      }
    }
    dispatch({ type: actionTypes.UPDATE_ACCESS_SETTINGS_REJECTED, payload: e });
    return e.response;
  }
};

//CREATE
export const createAccessSettingsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_ACCESS_SETTINGS });
  try {
    let response = await createAccessSettings({ accessSettings: data });

    dispatch({ type: actionTypes.CREATE_ACCESS_SETTINGS_FULFILLED });
    dispatch(openSnackbarAction({ msg: getLocalizedString("managersCreatedOK"), severity: "success" }));

    return response;
  } catch (e) {
    if (e.response.data.status === "DUPLICATED_DATA") {
      dispatch(openSnackbarAction({ msg: getLocalizedString("errorTwoEmployersAlready"), severity: "error" }));
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    dispatch({ type: actionTypes.CREATE_ACCESS_SETTINGS_REJECTED, payload: e });
    return e.response;
  }
};

//DELETE
export const deleteAccessSettingsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_ACCESS_SETTINGS });
  try {
    let response = await deleteAccessSettings(data);

    dispatch({ type: actionTypes.DELETE_ACCESS_SETTINGS_FULFILLED });
    dispatch(openSnackbarAction({ msg: getLocalizedString("managerDeletedOK"), severity: "success" }));

    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_ACCESS_SETTINGS_REJECTED, payload: e });
    if (e.response.data.status === "USER_PROCESS") {
      displayUserProcessError(dispatch);
    } else {
      dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    }
    return e.response;
  }
};
